import React from 'react';
import './DocsMenuProcedure.css';

export const DocsMenuProcedure = (props) => {
  return <div className="docs-menu-procedure">{props.procedure}</div>;
};
